/**
 * Shared status/level display metadata for the Goals tree, forms, and import UI.
 */

import type { GoalLevel, GoalStatus } from '@upskill/shared';
import type { BadgeVariant } from '../../components/ui';

export const STATUS_LABELS: Record<GoalStatus, string> = {
  ACTIVE: 'Active',
  MET: 'Met',
  ON_HOLD: 'On Hold',
  DISCONTINUED: 'Discontinued',
};

export const STATUS_BADGE_VARIANT: Record<GoalStatus, BadgeVariant> = {
  ACTIVE: 'success',
  MET: 'info',
  ON_HOLD: 'warning',
  DISCONTINUED: 'neutral',
};

export const STATUS_OPTIONS: Array<{ value: GoalStatus; label: string }> = (
  Object.keys(STATUS_LABELS) as GoalStatus[]
).map((value) => ({ value, label: STATUS_LABELS[value] }));

export const LEVEL_LABELS: Record<GoalLevel, string> = {
  DOMAIN: 'Domain',
  PROGRAM: 'Program',
  GOAL_TARGET: 'Goal/Target',
};

/** Hierarchy is strictly Domain -> Program -> Goal/Target; null once at a leaf level. */
export const NEXT_LEVEL: Record<GoalLevel, GoalLevel | null> = {
  DOMAIN: 'PROGRAM',
  PROGRAM: 'GOAL_TARGET',
  GOAL_TARGET: null,
};
